import React from 'react';
import { XMarkIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import fundoRodape from '@/assets/fundo-rodape.png'; // ajuste o caminho conforme necessário

const ModalContato = ({ aberto, onFechar }) => {
  if (!aberto) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 bg-black/70">
      {/* Imagem de fundo */}

      {/* Conteúdo do modal */}
<div
  className="relative rounded-2xl shadow-2xl p-8 w-[80%] max-w-md text-center space-y-6 transform transition-all duration-300 scale-100 hover:scale-105 z-10 bg-center bg-cover bg-no-repeat"
  style={{
    backgroundImage: `url(${fundoRodape})`,
    backgroundBlendMode: 'lighten',
    backgroundColor: 'rgba(201, 170, 123, 0.92)', // <== Cor #C9AA7B em RGBA com leve transparência
  }}
>

        <button
          onClick={onFechar}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition-colors duration-200"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        {/* Cabeçalho */}
        <h3 className="text-2xl md:text-3xl font-bold text-gray-800" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          Entre em Contato Conosco
        </h3>
        <p className="text-gray-600 text-sm md:text-base">
          Escolha a melhor forma de falar com nossa equipe!
        </p>

        {/* Botões */}
        <div className="flex flex-col gap-4">
          <a
            href="https://wa.me/5531993127020?text=Olá,%20estou%20vindo%20do%20site%20e%20gostaria%20de%20fazer%20um%20orçamento"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
          >
            <PhoneIcon className="h-5 w-5" />
            <span>WhatsApp</span>
          </a>
          <a
            href="/contatos"
            className="flex items-center justify-center gap-3 bg-gradient-to-r from-yellow-500 to-amber-600 hover:from-yellow-600 hover:to-amber-700 text-white py-3 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
          >
            <EnvelopeIcon className="h-5 w-5" />
            <span>Página de Contato</span>
          </a>
        </div>

        {/* Fechar */}
        <button
          onClick={onFechar}
          className="mt-6 text-sm text-gray-500 hover:text-gray-800 font-medium underline transition-colors duration-200"
        >
          Fechar
        </button>
      </div>
    </div>
  );
};

export default ModalContato;
